/* assets/blog-pep.js
 *
 * Tres coisas que o tema Wonder nao tem e que o artigo precisa:
 *
 *   1. tempo de leitura   nao existe reading time em lugar nenhum do tema
 *   2. sumario            nao existe table of contents; e o que ganha sitelink
 *   3. banner no meio     o bloco 'content' do main-article e limit: 1, entao
 *                         nao da para por secao no meio do corpo. Mas
 *                         article.content e impresso puro, sem filtro, entao
 *                         a marcacao escrita no editor da Shopify chega intacta
 *                         no HTML e e trocada aqui pelo <template> que o
 *                         snippets/artigo-banner-pep.liquid deixou na pagina.
 *
 *                         Duas formas valem:
 *                           <div data-pep-slot="serump1"></div>   preferida
 *                           [[produto:serump1]]                   na mao
 *
 *                         A preferida e um elemento vazio de proposito. O
 *                         structured-data-article.liquid publica article.content
 *                         inteiro no campo articleBody do BlogPosting, passando
 *                         por strip_html: a div some de la, e o shortcode em
 *                         texto NAO sumiria — o Google leria "[[produto:serump1]]"
 *                         como parte do artigo. E se o JS nao rodar, div vazia
 *                         nao aparece, enquanto o shortcode apareceria cru.
 *
 * Sem string acentuada aqui de proposito: todo rotulo visivel vem do Liquid,
 * que por sua vez recebe do JSON do template.
 */
(function () {
  'use strict';

  var PALAVRAS_POR_MINUTO = 200;
  var MINIMO_DE_TITULOS = 3;
  var SHORTCODE = /\[\[produto:([a-z0-9][a-z0-9-]*)\]\]/gi;

  function pronto(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* "Peptideo de cobre: o guia" -> "peptideo-de-cobre-o-guia" */
  function apelido(texto) {
    return texto
      .normalize('NFD')
      .replace(/[^\x00-\x7F]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  function tempoDeLeitura(corpo) {
    var alvo = document.querySelector('[data-pep-leitura]');
    var num = document.querySelector('[data-pep-leitura-num]');
    if (!alvo || !num) return;

    var palavras = (corpo.textContent || '').trim().split(/\s+/).length;
    num.textContent = String(Math.max(1, Math.round(palavras / PALAVRAS_POR_MINUTO)));
    alvo.hidden = false;
  }

  function sumario(corpo) {
    var caixa = document.querySelector('[data-pep-sumario]');
    var lista = document.querySelector('[data-pep-sumario-lista]');
    if (!caixa || !lista) return;

    var titulos = corpo.querySelectorAll('h2');
    if (titulos.length < MINIMO_DE_TITULOS) return;

    var usados = {};
    Array.prototype.forEach.call(titulos, function (h2, i) {
      var texto = (h2.textContent || '').trim();
      if (!texto) return;

      if (!h2.id) {
        var base = apelido(texto) || 'secao-' + (i + 1);
        var id = base;
        var n = 2;
        while (usados[id] || document.getElementById(id)) {
          id = base + '-' + n++;
        }
        h2.id = id;
      }
      usados[h2.id] = true;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.textContent = texto;
      li.appendChild(a);
      lista.appendChild(li);
    });

    if (lista.children.length) caixa.hidden = false;
  }

  function banners(corpo) {
    var moldes = document.querySelectorAll('[data-pep-produto]');
    if (!moldes.length) return;

    var porHandle = {};
    Array.prototype.forEach.call(moldes, function (t) {
      porHandle[t.getAttribute('data-pep-produto').toLowerCase()] = t;
    });

    /* Forma preferida: elemento vazio com data-pep-slot. */
    Array.prototype.forEach.call(corpo.querySelectorAll('[data-pep-slot]'), function (no) {
      var molde = porHandle[(no.getAttribute('data-pep-slot') || '').toLowerCase()];
      if (!molde) {
        no.remove();
        return;
      }
      no.parentNode.replaceChild(molde.content.cloneNode(true), no);
    });

    /* Forma escrita na mao: o shortcode sozinho no proprio paragrafo. Troca o
       paragrafo inteiro, senao sobra um <p> vazio em volta do banner. */
    Array.prototype.forEach.call(corpo.querySelectorAll('p, div'), function (no) {
      var texto = (no.textContent || '').trim();
      SHORTCODE.lastIndex = 0;
      var achado = SHORTCODE.exec(texto);
      if (!achado || achado[0] !== texto) return;

      var molde = porHandle[achado[1].toLowerCase()];
      if (!molde) {
        no.remove();
        return;
      }
      no.parentNode.replaceChild(molde.content.cloneNode(true), no);
    });

    /* Sobra: shortcode no meio de uma frase. Troca so o trecho de texto. */
    var caminhante = document.createTreeWalker(corpo, NodeFilter.SHOW_TEXT, null);
    var pendentes = [];
    var no;
    while ((no = caminhante.nextNode())) {
      SHORTCODE.lastIndex = 0;
      if (SHORTCODE.test(no.nodeValue)) pendentes.push(no);
    }

    pendentes.forEach(function (texto) {
      var frag = document.createDocumentFragment();
      var resto = texto.nodeValue;
      var pos = 0;
      var m;

      SHORTCODE.lastIndex = 0;
      while ((m = SHORTCODE.exec(resto))) {
        if (m.index > pos) {
          frag.appendChild(document.createTextNode(resto.slice(pos, m.index)));
        }
        var molde = porHandle[m[1].toLowerCase()];
        if (molde) frag.appendChild(molde.content.cloneNode(true));
        pos = m.index + m[0].length;
      }
      if (pos < resto.length) {
        frag.appendChild(document.createTextNode(resto.slice(pos)));
      }
      texto.parentNode.replaceChild(frag, texto);
    });
  }

  pronto(function () {
    var corpo = document.querySelector('.main-article__body');
    if (!corpo) return;

    /* Tempo de leitura antes do banner: o texto do banner e do preco nao
       pode entrar na contagem de palavras do artigo. */
    tempoDeLeitura(corpo);
    banners(corpo);
    sumario(corpo);
  });
})();
